import { useMemo } from 'react';
import { use100vh } from 'react-div-100vh';

import { useIsDesktop } from '@/hooks/useIsDesktop';

export const usePageContainerHeight = () => {
  const { isDesktop } = useIsDesktop();

  const realHeight = use100vh();

  const containerHeight = useMemo(() => {
    if (realHeight) {
      if (isDesktop) {
        return realHeight - 243; // The size of the footer
      }

      return realHeight - 51; // The size of the mobile navbar
    }

    return 'auto';
  }, [realHeight, isDesktop]);

  return { containerHeight };
};
